import { useEffect, useState } from 'react';

export type SessionUser = { kind: 'employee' | 'guest'; name: string; email: string | null };

export function useSessionUser(): SessionUser | null | undefined {
    const [user, setUser] = useState<SessionUser | null>();

    useEffect(() => {
        const controller = new AbortController();
        fetch('/api/me', { signal: controller.signal })
            .then((response) => (response.ok ? (response.json() as Promise<SessionUser>) : null))
            .then(setUser)
            .catch((error: unknown) => {
                if (!controller.signal.aborted) {
                    console.error(error);
                    setUser(null);
                }
            });
        return () => {
            controller.abort();
        };
    }, []);

    return user;
}
